import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { L1L3AuthService } from 'ngx-auth-util-lib';
import { HekaAccountMenu } from 'ngx-heka-design-lib';
import { Subscription } from 'rxjs';
import { AccountMenuService } from 'src/app/services/account-menu.service';
import { DomainHandlerService } from 'src/app/services/domain-handler-service';
import { LoadingService } from 'src/app/services/loading.service';
import { MultiDomainMgmtService } from 'src/app/services/multi-domain-mgmt.service';
import { environment } from '../../../environments/local/environment';

@Component({
  selector: 'app-no-app-permission',
  templateUrl: './no-app-access.component.html',
  styleUrls: ['./no-app-access.component.scss'],
  standalone: false
})
export class NoAppAccessComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();

  description = '';
  accountMenu?: HekaAccountMenu;
  env = environment;

  constructor(
    public authService: L1L3AuthService,
    public domainHandlerService: DomainHandlerService,
    public loadingService: LoadingService,
    private multiDomainMgmtService: MultiDomainMgmtService,
    private accountMenuService: AccountMenuService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.getProfile();
  }

  private getProfile() {
    this.loadingService.setLoading(true);
    this.subscriptions.add(
      this.multiDomainMgmtService.getSharedMultiDomainProfile().subscribe({
        next: profile => {
          if (profile) {
            this.accountMenu = this.accountMenuService.buildAccountMenu(profile);

            const activeDomain = profile.domains.find(d => d.active);

            if (activeDomain) {
              this.description = this.translateService.instant('OAUTH.NO_ACCESS.DESCRIPTION', {
                companyName: activeDomain.companyName
              });
            }
          }
          this.loadingService.setLoading(false);
        },
        error: err => {
          this.loadingService.setLoading(false);
          throw err;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
